import './navigableDirective.scss';

const navigableDirective = function () {
    return {
        restrict: 'E',
        scope: {},
        transclude: {
            'widgetContent': 'widgetContent',
            'navigableContent': 'navigableContent'
        },
        // language=file-reference
        template: require('./navigableDirective.html')
    }
};

export const NavigableDirective = [navigableDirective];